import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleAddSubAdminTitle = styled.p`
  color: ${theme.colors.primary};
  text-align: center;
  font-size: 18px;
`
export const StyleAddSubAdminMessageWrapper = styled.div`
  background-color: #fdf0cf;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  padding: 12px;
`
export const StyleAddSubAdminMessage = styled.p`
  font-size: 13px;
  color: ${theme.colors.text};
`
